import Vue from 'vue'
import Router from 'vue-router'
import getMenu from '~common/components/Admin/getMenu.vue'
import { MAGICCUBE_ROUTES } from '~common/commonModule/magicCube/router/index.js'
import xesBaseFn from '~common/assets/js/xes.base.js'
Vue.use(Router)

let routes = [
  {
    path: '/Admin/getMenu',
    name: 'getMenu',
    component: getMenu
  }
]

routes = routes.concat(MAGICCUBE_ROUTES)

const router = new Router({
  routes: routes
})

// 为了每个路由链接验证token
xesBaseFn.isTokenRouter(router)

Router.prototype.open = function (url, id) {
  var ids = id ? `/${id}` : "";
  var mode = router.mode == "hash" ? `/#/` : `/`
  top.open(mode + url + ids);
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./module/magicCube/src/router/index.js